import { PositionStatusFilter } from 'api/positions/getAllPositions'

export const approvalStatuses: {
  label: string
  value: PositionStatusFilter
}[] = [
  { label: 'All', value: 'all' },
  { label: 'Approved', value: 'approved' },
  { label: 'Unapproved', value: 'unapproved' },
]
